import React from 'react';
import { Box, AspectRatio, Heading, HStack } from '@chakra-ui/react';
import Section from '@components/atoms/Section';
import Wrapper from '@components/atoms/Wrapper';
import LexicalRichText from '@components/atoms/LexicalRichText';
import Image from '@components/atoms/Image';
import LazyLoad from '@components/atoms/LazyLoad';

const RecipeList = ({ ...props }) => {
  return (
    <Section {...props}>
      <Wrapper maxWidth="75.75rem">
        {props?.data?.recipes !== null && props?.data?.recipes?.length > 0 && (
          <Box>
            <HStack
              flexWrap="wrap"
              justifyContent={{ md: `space-between` }}
              columnGap="16">
              {props?.data?.recipes?.map((entry, index) => (
                <Box
                  key={entry.id}
                  width={{ base: `100%`, md: `calc(50% - 2rem)` }}>
                  <LazyLoad>
                    <Box className="button-hover">
                      <AspectRatio
                        ratio={4 / 3}
                        overflow="hidden"
                        display="block">
                        <Image image={entry.image} />
                      </AspectRatio>
                      <Heading
                        as="h2"
                        fontSize={{ base: `lg`, md: `3xl` }}
                        color="white"
                        pt={{ base: 6, md: 8 }}
                        mb={{ base: 4, md: 6 }}
                        textTransform="uppercase">
                        {entry.title}
                      </Heading>
                      <LexicalRichText
                        data={{
                          richText: {
                            data: {
                              richText: entry.description.data.description
                            }
                          }
                        }}
                        paddingSides="0"
                        maxWidth="none"
                      />
                    </Box>
                  </LazyLoad>
                </Box>
              ))}
            </HStack>
          </Box>
        )}
      </Wrapper>
    </Section>
  );
};

export default RecipeList;
